export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: 'Dashboard',
        icon: {
          src: require('@/assets/img/all/home.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Report Management',
        to: '/ReportManagement',
        icon: {
          src: require('@/assets/img/all/document-text.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
        class: 'sidebar-item-text'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Incident Map',
        to: '',
        icon: {
          src: require('@/assets/img/all/document-text.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
    
     
        {
        _name: 'CSidebarNavItem',
        name: 'Officers Management',
        to: '',
        icon: {
          src: require('@/assets/img/all/document-text.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
     
      
      
     
    ]
  },
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Setting',
        to: 'Setting',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logout',
        to: 'Logout',
      },
    ],
    _style: 'margin-top: auto;', // Pushes the navigation items to the bottom of the sidebar
  }
]